<template>
  <v-container>
    <v-row>
      <v-col>
        <p>
          Возвращает последний прогноз для указанного территории. Необходимо указать идентификатор территории
          <b>{presetId}</b>.
        </p>

        <div class="text-subtitle-1">Заголовки запроса</div>
        <v-simple-table>
          <thead>
            <tr>
              <td>
                <b>Заголовок</b>
              </td>
              <td>
                <b>Описание</b>
              </td>
              <td>
                <b>Пример значения</b>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Authorization</td>
              <td>JWT токен доступа</td>
              <td>Bearer eyJhbGciOiJSUzI1NiIsImtp...</td>
            </tr>
            <tr>
              <td>Accept-Encoding</td>
              <td>
                Вы можете указать параметр gzip для сжатия ответа. Настоятельно рекомендуем использовать этот заголовок!
                Например, если без сжатия, ответ занимает 4 мегабайта, то с gzip сжатием он будет занимать около 150 килобайт.
              </td>
              <td>gzip</td>
            </tr>
          </tbody>
        </v-simple-table>

        <div class="text-subtitle-1">Типы запросов</div>

        <v-simple-table>
          <thead>
            <tr>
              <td>
                <b>Запрос</b>
              </td>
              <td>
                <b>Описание</b>
              </td>
              <td>
                <b>Пример</b>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>По координатам и домену</td>
              <td>{lat} - широта; {lon} - долгота</td>
              <td>
                <code>curl -H 'Authorization: Bearer eyJhbGciOiJSUzI1NiIsImtp...' '{{ $settings.VUE_APP_GATEWAY_SERVICE_ENDPOINT }}/1.2/forecast/preset/600e9a673f3e9f10dd65f0fe'</code>
              </td>
            </tr>
          </tbody>
        </v-simple-table>

        <div class="text-subtitle-1">Ответ</div>

        <v-simple-table class="table">
          <thead>
            <tr>
              <td>
                <b>Пример ответа</b>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <json-viewer :value="response" copyable boxed sort></json-viewer>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card>
          <div class="text-h5">Территория</div>
          <div class="text-subtitle-1">Общие сведения</div>
          <p>
            Для работы с данным API вам необходимо передать три параметра: широту, долготу и идентификатор территории. Широта и долгота определяют координаты точки
            в которой вы ходите получить прогноз. Идентификатор территории определяет территорию для которой посчитан прогноз.
          </p>
          <p>Получить список активных территорий можно с помощью API.</p>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: function() {
    return {
      response: {
        location: {
          type: "Feature",
          properties: {},
          geometry: {
            type: "Point",
            coordinates: [43.565351743042619, 54.827629890449167]
          }
        },
        parameters: [
          {
            level_type: "depthBelowLandLayer",
            level: 300,
            name: "t",
            value: 220.3386328125,
            unit: "m"
          }
        ],
        refTime: "2017-12-07T03:00:00Z",
        predict: 0,
        ts_lat: 0,
        ts_lng: 0
      }
    };
  }
};
</script>